import { createContext, useContext } from "react";
import { truthOrFail } from "@/utils/helpers";
import { Signal } from "@/utils/signal";

export interface VersionContextValue {
  /** Live URL version ?? last persisted selection; used to build version-aware tab links. */
  selectedVersion: string | null;
  /** selectedVersion ?? latest; used to display the badge. Null only when there are no versions. */
  currentVersion: string | null;
  /** Open-state for the scaffold's version history/selection panel, shared so the header badge and
   *  the in-aside selector button can both open it. */
  openPanel: Signal<boolean>;
}

export const VersionContext = createContext<VersionContextValue | null>(null);

export const useVersion = () =>
  truthOrFail(
    useContext(VersionContext),
    "VersionProvider not in component tree",
  );
